// @greenlight-spec: 28-it-dashboard-ui.md
import { CheckCircle2, CircleMinus, Loader2, XCircle, type LucideIcon } from 'lucide-react';

import { type StatusBadgeVariant } from '@/components/greenlight/StatusBadge';

export interface PipelineIconSpec {
  Icon: LucideIcon;
  className: string;
  spin?: boolean;
}

// Compact pipeline indicator shared by the apps-list Pipeline column and the
// Grid card: a shape-distinct icon (not a color-only dot) so it stays legible
// without color and keeps the row narrow. The label travels in aria-label/title.
export function pipelineIcon(variant: StatusBadgeVariant): PipelineIconSpec {
  switch (variant) {
    case 'active':
      return { Icon: CheckCircle2, className: 'text-gl-green-text' };
    case 'failed':
      return { Icon: XCircle, className: 'text-gl-red-text' };
    case 'deploying':
      return { Icon: Loader2, className: 'text-gl-amber-text', spin: true };
    default:
      return { Icon: CircleMinus, className: 'text-muted-foreground' };
  }
}
